import { gsap } from "gsap";

export function playHeroIntro() {
  gsap.from(
    "#home *",
    {
      opacity: 0,
      y: 8,
      duration: 0.6,
      stagger: 0.05,
      ease: "power2.out",
    }
  );

  gsap.to("#name-glow", {
    opacity: 1,
    duration: 0.15,
    delay: 0.8,
    yoyo: true,
    repeat: 1,
  });
}